<template>
  <Modal
      v-model="modalStatus"
      :title="title">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
      <FormItem label="楼层">
        <Select v-model="formValidate.floorId" placeholder="请选择" :disabled="deviceId === null || deployStatus">
          <Option :value="item.value" v-for="item in mapFloor"
                  :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem label="设备坐标">
        <Row>
          <Col span="11">
            <FormItem prop="x">
              <Input v-model="formValidate.x" placeholder="请输入" disabled/>
            </FormItem>
          </Col>
          <Col span="2" style="text-align: center; color: #999999;">-</Col>
          <Col span="11">
            <FormItem prop="y">
              <Input v-model="formValidate.y" placeholder="请输入" disabled/>
            </FormItem>
          </Col>
        </Row>
      </FormItem>
      <FormItem label="设备名称" prop="name">
        <Input v-model="formValidate.name" placeholder="请输入" />
      </FormItem>
      <FormItem label="设备编号" prop="number">
        <Input v-model="formValidate.number" placeholder="请输入" :disabled="deviceId != null" />
      </FormItem>
      <FormItem label="设备类别" prop="deviceTypeId">
        <Select v-model="formValidate.deviceTypeId" placeholder="请选择" :disabled="showStatus">
          <Option :value="item.value" v-for="item in categoryList"
                  :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem label="设备位置" prop="location">
        <Input v-model="formValidate.location" type="textarea"
               :autosize="{minRows: 3,maxRows: 5}" placeholder="请输入" />
      </FormItem>
      <FormItem label="设备状态" prop="status">
        <RadioGroup v-model="formValidate.status">
          <Radio label="启用">启用</Radio>
          <Radio label="闲置">闲置</Radio>
          <Radio label="报废">报废</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" @click="handleReset()">取消</Button>
      <Button type="primary" :loading="requestStatus" @click="handleSubmit('formValidate')">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import { DEVICE_EDIT, DEVICE_TYPE_NOPAGE} from '../../config/api'
  import {conversionFrom} from '../../utils/helper'
  export default {
    data() {
      return {
        //标题信息
        title: '',
        //弹框状态
        modalStatus: false,
        //设备类别列表
        categoryList: [],
        //验证表单
        formValidate: {
          floorId: '',
          x: '',
          y: '',
          name: '',
          number: '',
          deviceTypeId: '',
          location: '',
          status: '启用'
        },
        //表单验证规则
        ruleValidate: {
          floorId: [
            { required: true, type:  'number', message: '请选择楼层', trigger: 'change' }
          ],
          x: [
            { required: true, type:  'number',message: '请输入x坐标', trigger: 'blur' },
          ],
          y: [
            { required: true, type:  'number',message: '请输入y坐标', trigger: 'blur' },
          ],
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' }
          ],
          number: [
            { required: true, message: '请输入编号', trigger: 'blur' }
          ],
          deviceTypeId: [
            { required: true, type:  'number', message: '请选择类别', trigger: 'change' }
          ],
          location: [
            { required: true, message: '请输入位置', trigger: 'blur' }
          ],
          status: [
            { required: true, message: '请选择状态', trigger: 'change' },
          ]
        },
        //请求状态
        requestStatus: false,
        //展示状态
        deployStatus: true
      }
    },
    props: ['deviceId', 'deviceData', 'type'],
    created() {
      this.requestDeviceCategory()
    },
    methods: {
      //请求设备类别
      requestDeviceCategory() {
        this.$get(`${DEVICE_TYPE_NOPAGE}/${this.currentScene}`).then(res => {
          let categoryList = [];
          res.forEach(arr => {
            categoryList.push({label: arr.name, value: arr.id})
          });
          this.categoryList = categoryList;
        }).catch(err => {
          //异常情况
          this.$httpErr(err, DEVICE_TYPE_NOPAGE)
        })
      },
      //初始化表单数据
      initForm() {
        if (this.deviceId === null) {
          // 新增设备时, 切换楼层number => id
          this.mapFloor.forEach(arr => {
            if (arr.number === this.deviceData.groupID) {
              this.formValidate.floorId = arr.value;
            }
          });
        } else {
          this.formValidate.floorId = this.deviceData.floorId;
        }
        for (let val in this.formValidate) {
          if (this.deviceData[val] !== undefined) {
            this.formValidate[val] = this.deviceData[val];
          }
        }
      },
      //重置表单数据
      resetFormData(name) {
        this.$refs[name].resetFields();
        for (let val in this.formValidate) {
          this.formValidate[val] = (val === 'status') ? '启用' : '';
        }
      },
      //表单提交
      handleSubmit (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            //验证成功
            this.submitDevice()
          }
        })
      },
      //取消提交
      handleReset() {
        this.modalStatus = false;
      },
      //提交部署设备信息
      submitDevice() {
        this.requestStatus = true;
        let data = {...this.formValidate};
        let httpType = this.deviceId !== null ? '$put' : '$post';
        let url = this.deviceId !== null ? `${DEVICE_EDIT}/${this.currentScene}/${this.deviceId}` :
          `${DEVICE_EDIT}/${this.currentScene}`;
        this[httpType](url, conversionFrom(data)).then(res => {
          this.requestStatus = false;
          this.modalStatus = false;
          let type = this.deviceId !== null ? 'update' : 'new';
          let content = {
            type: type,
            data: data
          };
          this.$emit('deviceEvent', content)
        }).catch(err => {
          this.requestStatus = false;
          //异常情况
          this.$httpErr(err, DEVICE_EDIT)
        })
      },
    },
    computed: {
      ...mapGetters([
        'currentScene',
        'mapFloor',
      ]),
    },
    watch: {
      modalStatus: function(val) {
        if (val) {
          this.title = this.deviceId !== null ? '编辑设备' : '新增设备';
          this.deployStatus = (this.deviceId !== null) && (this.type === 'deploy');
          this.initForm()
        } else {
          this.resetFormData('formValidate')
          this.$emit('deviceEvent', {type: 'close'})
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./index";
</style>
